// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__Ya0cb","mainContent":"MainLayout_mainContent__lk1IV"};